import { render } from "./Experiences.vue?vue&type=template&id=488f1388"
const script = {}
script.render = render

export default script